import styled, { css } from 'styled-components'

const SvgComponent = styled.svg`

    width: 70px;
    height: 70px;

    @media screen and (max-width: 1300px) {
        width: 50px;
        height: 50px;
    }

    @media screen and (max-width: 550px) {
        width: 35px;
        height: 35px;
    }

    ${({ download }) => download && css`
        width: 35px;
        height: 35px;
    `}

    ${({ size }) => size && css`
        width: 25px;
        height: 25px;
    `}

`
const SVGWrapper = styled.div`
    display: flex;
    flex-flow: column;
    width: ${({ width = 'fit-content' }) => width};
    align-items: center;
    justify-content: center;
    align-self: ${({ alignself = "center" }) => alignself};
`
const MessageComponent = styled.span`
    width: fit-content;
`

const Loader = ({ message, download, alignself, width, size }) => {
    return (
        <SVGWrapper alignself={alignself} width={width}>
            <SvgComponent size={size} download={download} xmlns="http://www.w3.org/2000/svg" 
                xmlnsXlink="http://www.w3.org/1999/xlink" 
                style={{ 
                    marginBottom: 'auto ',
                    display: 'block' 
                }} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" r="23" stroke="#c8c9c7" strokeWidth="3" fill="none"></circle>
                <circle cx="50" cy="50" r="23" stroke="#ff9800" strokeWidth="8" strokeLinecap="round" fill="none">
                <animateTransform 
                    attributeName="transform" 
                    type="rotate" 
                    repeatCount="indefinite" 
                    dur="2.272727272727273s" 
                    values="0 50 50;180 50 50;720 50 50" 
                    keyTimes="0;0.5;1">    
                </animateTransform>
                <animate 
                    attributeName="stroke-dasharray" 
                    repeatCount="indefinite" 
                    dur="2.272727272727273s" 
                    values="0 144.51326206513048;128.61680323796614 15.896458827164338;0 144.51326206513048" 
                    keyTimes="0;0.5;1">    
                </animate>
                </circle>
            </SvgComponent>
            { message && <MessageComponent> { message } </MessageComponent> }
        </SVGWrapper>
    )
}

export default Loader